const PRODUCTION = {
    baseUrl: 'https://cybreplus.ncsa.or.th/',
    apiUrl: 'https://cybreplus.ncsa.or.th/api',
    fileUpload: 'https://cybreplus.ncsa.or.th/FileUpload/',
    phpUrl: 'https://cybreplus.ncsa.or.th/dev',
    thaiDAuthUrl: 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/',
    thaiDClientId: 'WmlNUVhQMFg5S1NySnhlMVFuTFZyRWtTcERETnAxV08',
    thaiDRedirectUri: 'https://cybreplus.ncsa.or.th/dev/thaid_callback.php'
};

const UAT = {
    baseUrl: 'https://uat-cybreplus-api.ncsa.or.th/',
    apiUrl: 'https://uat-cybreplus-api.ncsa.or.th/api',
    fileUpload: 'https://uat-cybreplus-api.ncsa.or.th/FileUpload/',
    phpUrl: 'https://uat-cybreplus.ncsa.or.th/dev',
    thaiDAuthUrl: 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/',
    thaiDClientId: 'WmlNUVhQMFg5S1NySnhlMVFuTFZyRWtTcERETnAxV08',
    thaiDRedirectUri: 'https://uat-cybreplus.ncsa.or.th/dev/thaid_callback.php'
};

const LOCAL = {
    baseUrl: 'https://uat-cybreplus-api.ncsa.or.th/',
    apiUrl: 'http://localhost:8181/api',
    fileUpload: 'http://localhost:8181/FileUpload/',
    phpUrl: 'http://dev.ncsa.localhost',
    thaiDAuthUrl: 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/',
    thaiDClientId: 'WmlNUVhQMFg5S1NySnhlMVFuTFZyRWtTcERETnAxV08',
    //thaiDRedirectUri: 'https://uat-cybreplus.ncsa.or.th/dev/thaid_callback.php'
    thaiDRedirectUri: 'http://dev.ncsa.localhost/thaid_callback.php'
};
/*
const LOCAL = {
    baseUrl: 'https://uat-cybreplus-api.ncsa.or.th/',
    apiUrl: 'http://119.59.114.101:8181/api',
    fileUpload: 'http://119.59.114.101:8181/FileUpload/',
    phpUrl: 'http://119.59.114.101/NCSA-Dev',
    thaiDAuthUrl: 'https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/',
    thaiDClientId: 'WmlNUVhQMFg5S1NySnhlMVFuTFZyRWtTcERETnAxV08',
    //thaiDRedirectUri: 'https://uat-cybreplus.ncsa.or.th/dev/thaid_callback.php'
    thaiDRedirectUri: 'http://119.59.114.101/NCSA-Dev/thaid_callback.php'
};
*/
//export const Config = PRODUCTION;
export const Config = UAT;

//export const Config = process.env.NODE_ENV === 'development' ? dev : prod;